import { LeanFormSchema, fieldRef } from '../types/config-form.types';
import { V3UnbalancedSupportSettings } from 'ngx-modbus';

export const UNBALANCED_SUPPORT_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'unbalanced-support-settings',
  name: 'Unbalanced Support Settings',
  sections: [{
    id: 'unbalanced',
    labelKey: 'unbalancedSupportSettings',
    registerTable: 'V3UnbalancedSupportSettings',
    fields: [
      fieldRef(V3UnbalancedSupportSettings, 'UnbalancedSupport_Control'),
    ],
  }],
};
